<template>
  <div class="space-y-2 p-4">
    <viewTitle title="业务管理 / 过磅确认管理" :showReturn="false"/>
    <div class="text-center">
      <el-radio-group size="small" v-model="weight_type" @change="onReset">
        <el-radio-button
            v-for="item in weightType"
            :key="item.id"
            :label="item.id"
        >
          <div class="py-1 px-12">
            {{ item.name }}
          </div>
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="flex items-center justify-end">
      <div>
        <el-button
            v-has="['c-booking-delivery-addPound']"
            @click="onAdd"
            type="primary"
            size="small"
        >新增
        </el-button
        >
        <el-button
            v-has="['c-pound-record-export']"
            @click="onExport"
            size="small"
        >导出
        </el-button
        >
      </div>
    </div>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="预约单号">
        <el-input
            clearable
            v-model="queryParam.booking_code"
            placeholder="请输入预约单号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
            clearable
            v-model="queryParam.license_plate"
            placeholder="请输入车牌号"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="SAP传输状态">
        <el-select
            class="w-60"
            clearable
            v-model="queryParam.push_sap_state"
            placeholder="请选择SAP传输状态"
        >
          <el-option
              v-for="item in pushState"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地磅推送状态">
        <el-select
            class="w-60"
            clearable
            v-model="queryParam.push_pound_state"
            placeholder="请选择SAP传输状态"
        >
          <el-option
              v-for="item in pushState"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="timeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="门岗">
        <el-input
            clearable
            v-model="queryParam.door_name"
            placeholder="请输入门岗"
            class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" type="primary" size="small"
        >刷新数据
        </el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
        class="mt-4"
        :isIndex="false"
        :isSelection="false"
        :selection.sync="rowKeySelection"
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        row-key="booking_id"
        @loadPage="loadData"
    >
      <template slot="booking_code" slot-scope="{ row }">
        <c-link :underline="true" @click="onBookingDetail(row)">{{
            row.booking_code
          }}
        </c-link>
      </template>
      <template slot="create_time" slot-scope="{ row }">
        {{ row.create_time | timeFormat }}
      </template>
      <template slot="car_business_list" slot-scope="{ row }">
        <div v-for="item in row.car_business_list" :key="item.id">
          {{ item.name }}
        </div>
      </template>
      <template slot="action" slot-scope="{ row }">
        <span class="space-x-2">
          <c-link
              v-if="
              baseInfo.c3_state == 1 &&
                (row.push_sap_state == 2 || row.push_sap_state == 4)
            "
              @click="onInstruction(row)"
              label="发送指令"
          ></c-link>
          <c-link
              @click="onSendCard(row)"
              v-if="showSendOrReturn(row, 1) && row.weight_type == 1"
          >发卡</c-link
          >
          <c-link
              @click="onReturnCard(row)"
              v-if="showSendOrReturn(row, 2) && row.weight_type == 2"
          >退卡</c-link
          >
          <c-link
              v-has="['c-pound-record-sap']"
              v-if="canPushSap(row) && row.hand_make != 1"
              @click="onPushSap(row)"
              label="传输SAP"
          ></c-link>
          <c-link
              v-has="['c-pound-record-close']"
              v-if="canPushSap(row)"
              @click="onCloseBusiness(row)"
              label="人工关闭"
          ></c-link>
          <c-link
              v-if="
              row.push_sap_state == 2 &&
                (row.push_pound_state == 1 || row.push_pound_state == 3)
            "
              @click="onPushPound(row)"
              v-has="['c-pound-record-pound']"
              label="推送地磅"
          ></c-link>
          <c-link
              v-if="
              weight_type == 1 &&
                row.push_sap_state == 2 &&
                row.push_pound_state == 2
            "
              @click="onAgain(row)"
              v-has="['c-pound-record-again']"
              label="重新进厂"
          ></c-link>
          <c-link
              @click="onView(row)"
              v-has="['c-pound-record-detail']"
              label="查看"
          ></c-link>
        </span>
      </template>
    </c-table>
    <push-sap ref="pushSap" @ok="refreshData"/>
    <closeBusiness ref="closeBusiness" @ok="refreshData"/>
    <againInCom ref="againInCom" @ok="refreshData"/>
    <addModal ref="addModal" @ok="refreshData"/>
    <pushSapLeave ref="pushSapLeave" @ok="refreshData"/>
    <AccessCardModal
        send-url="/api/queue/admin/delivery_send_card"
        return-url="/api/queue/admin/delivery_return_card"
        :showDoor="true"
        ref="accessCard"
        @ok="refreshData"
    />
  </div>
</template>

<script>
import pushSap from "./components/pushSap.vue";
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import closeBusiness from "./components/closeBusiness.vue";
import againInCom from "./components/againInCom.vue";
import addModal from "./components/addModal.vue";
import pushSapLeave from "./components/pushSapLeave.vue";
import AccessCardModal from "../AccessCard/components/AccessCardModal.vue";
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      initTime: 0,
      weight_type: 1,
      pushState: [
        {id: 1, name: "未传输"},
        {id: 2, name: "已传输"},
        {id: 3, name: "传输失败"},
        {id: 4, name: "人工关闭"},
        {id: 5, name: "系统关闭"}
      ],
      weightType: [
        {id: 1, name: "过磅进厂"},
        {id: 2, name: "过磅出厂"}
      ],
      columns: [
        {
          label: "所属基地",
          prop: "base_name",
          formatData: () => this.baseInfo.com_name
        },
        {width: 100, label: "门岗", prop: "door_name"},
        {
          label: "过磅类型",
          prop: "weight_type",
          formatData: row => {
            const weight_type = this.weightType.find(
                item => item.id == row.weight_type
            );
            return weight_type ? weight_type.name : "--";
          }
        },
        {label: "称台", prop: "weighbridge_code"},
        {width: 160, label: "预约号", prop: "booking_code"},
        {width: 120, label: "订单号", prop: "order_code"},
        {label: "车辆业务类型", prop: "car_business_list"},
        {label: "供应商", prop: "supplier_name"},
        {width: 100, label: "车牌号", prop: "license_plate"},
        {width: 80, label: "重量", prop: "weight", formatData: row => row.weight + "T"},
        {width: 160, label: "创建时间", prop: "create_time"},
        {
          label: "发卡状态",
          prop: "access_card_state",
          show: () => this.baseInfo.door_card_state == 1,
          formatData: row => {
            const {booking_queue} = row;
            if (booking_queue) {
              const {access_card_state} = booking_queue;
              if (access_card_state == 1) {
                return "未发卡";
              } else if (access_card_state == 2) {
                return "已发卡";
              } else if (access_card_state == 3) {
                return "已退卡";
              }
            }
            return "未发卡";
          }
        },
        {
          label: "SAP传输状态",
          prop: "push_sap_state",
          formatData: row => {
            const {push_sap_state} = row;
            const stateItem = this.pushState.find(
                item => item.id == push_sap_state
            );
            return stateItem ? stateItem.name : "--";
          }
        },
        {
          label: "地磅推送状态",
          prop: "push_pound_state",
          formatData: row => {
            const state = this.pushState.find(
                item => item.id == row.push_pound_state
            );
            return state ? state.name : "--";
          }
        },
        {
          label: "门禁指令",
          prop: "c3_state",
          formatData: row => {
            if (row.c3_state == 1) {
              return "发送成功";
            }
            if (row.c3_state == 2) {
              return "发送失败";
            }
            return "未发送";
          },
          show: () => this.baseInfo.c3_state == 1
        },
        {
          label: "操作",
          prop: "action"
        }
      ],
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_booking_pound",
          data: {
            ...params,
            weight_type: this.weight_type
          },
          noLoading: true
        });
      },
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_booking_pound",
          data: {
            ...params,
            weight_type: this.weight_type
          }
        });
      },
      count: 0,
      monitor: null,
      monitorInterval: 5000,
      monitorMinInterval: 5000,
      monitorMaxInterval: 30000,
      monitorStep: 5000,
      monitorPaused: false,
      visibilityHandler: null
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  watch: {
    weight_type() {
      this.restartMonitor();
    }
  },
  components: {
    pushSap,
    againInCom,
    closeBusiness,
    addModal,
    pushSapLeave,
    AccessCardModal
  },
  mixins: [initListMinxin, mixinTableLyout],
  methods: {
    onAdd() {
      this.$refs.addModal.onOpen(this.weight_type);
    },
    // 发卡
    onSendCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 1);
    },
    // 退卡
    onReturnCard(row) {
      this.$refs.accessCard.onOpen(row.booking_id, 2);
    },
    onCloseBusiness(row) {
      this.$refs.closeBusiness.onOpen(row);
    },
    showSendOrReturn(row, state) {
      let status = false;
      if (this.baseInfo.door_card_state == 1) {
        const {booking_queue, push_sap_state} = row;
        if (push_sap_state == 1 || push_sap_state == 2) {
          if (booking_queue) {
            if (booking_queue.access_card_state == state) {
              status = true;
            }
          } else {
            status = true;
          }
        }
      }
      return status;
    },
    onAgain(row) {
      this.$refs.againInCom.onOpen(row);
    },
    canPushSap(row) {
      return row.push_sap_state == 1 || row.push_sap_state == 3;
    },
    async onPushSap(row) {
      if (row.weight_type == 1) {
        this.$refs.pushSap.onOpen(row);
      } else {
        // if (row.booking_state != 46) {
        //   this.$alert(
        //     "该记录不是待出厂状态，不能传输SAP！",
        //     "过磅出厂传输SAP确认",
        //     {
        //       showCancelButton: true,
        //       showConfirmButton: false
        //     }
        //   );
        //   return;
        // }
        this.$refs.pushSapLeave.onOpen(row);
      }
    },
    onPushPound(row) {
      this.$confirm("确认推送地磅系统吗？", "提示").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/push_pound",
            data: {
              id: row.id
            }
          });
          this.$message.success("地磅数据已发送");
          this.refreshData();
        } catch (error) {
        }
      });
    },
    onView(row) {
      this.$router.push({
        path: "/rhqy/service/WeighConfirmManage/Detail/" + row.id
      });
    },
    onBookingDetail(row) {
      window.open(
          this.$router.resolve(
              `/rhqy/service/AppointDeliveryRecord/Detail/${row.booking_info_id}`
          ).href,
          "_blank"
      );
    },
    scheduleMonitor() {
      this.clearMonitor();
      if (this.monitorPaused) {
        return;
      }
      this.monitor = setTimeout(() => {
        this.monitorCheck();
      }, this.monitorInterval);
    },
    clearMonitor() {
      if (this.monitor) {
        clearTimeout(this.monitor);
        this.monitor = null;
      }
    },
    setupVisibilityListener() {
      if (this.visibilityHandler) {
        return;
      }
      this.visibilityHandler = this.handleVisibilityChange.bind(this);
      document.addEventListener("visibilitychange", this.visibilityHandler);
    },
    handleVisibilityChange() {
      this.monitorPaused = document.hidden;
      if (this.monitorPaused) {
        this.clearMonitor();
      } else {
        this.monitorInterval = this.monitorMinInterval;
        this.monitorCheck(true);
      }
    },
    async monitorCheck(forceRefresh = false) {
      if (this.monitorPaused) {
        return;
      }
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/query_booking_pound_latest",
          data: {
            begin_time: this.initTime,
            weight_type: this.weight_type,
            limit: 5
          },
          noLoading: true
        });
        const {records = [], latest_time = 0, new_count = 0} =
        (res.data && res.data.data) || {};
        if (records.length > 0) {
          this.notifyNewRecords(records);
          if (latest_time) {
            this.initTime = Number(latest_time) + 1;
          }
          this.refreshData();
          this.monitorInterval = this.monitorMinInterval;
        } else if (!forceRefresh && new_count === 0) {
          this.monitorInterval = Math.min(
              this.monitorInterval + this.monitorStep,
              this.monitorMaxInterval
          );
        }
      } catch (error) {
        this.monitorInterval = Math.min(
            this.monitorInterval + this.monitorStep,
            this.monitorMaxInterval
        );
      } finally {
        this.scheduleMonitor();
      }
    },
    notifyNewRecords(records = []) {
      if (!records.length) {
        return;
      }
      this.$notify.closeAll();
      const typeName =
          (this.weightType.find(e => this.weight_type === e.id) || {}).name || "";
      records.forEach((item, index) => {
        setTimeout(() => {
          const timeText = item.create_time
              ? moment.unix(item.create_time).format("YYYY-MM-DD HH:mm:ss")
              : "";
          this.$notify.info({
            title: `${typeName}提醒`,
            duration: 0,
            position: "bottom-right",
            dangerouslyUseHTMLString: true,
            message: `<p>新收到预约号${item.booking_code}，车牌：${
                item.license_plate
            }的${typeName}记录</p><span>${timeText}</span>`,
            onClick: () => {
              window.open(
                  this.$router.resolve(
                      "/rhqy/service/WeighConfirmManage/Detail/" + item.id
                  ).href,
                  "_blank"
              );
            }
          });
        }, 100 * index);
      });
    },
    restartMonitor() {
      this.clearMonitor();
      this.getServiceCurrentTime().then(() => {
        this.monitorInterval = this.monitorMinInterval;
        this.monitorPaused = document.hidden;
        if (!this.monitorPaused) {
          this.monitorCheck(true);
        }
      });
    },
    teardownMonitor() {
      this.clearMonitor();
      if (this.visibilityHandler) {
        document.removeEventListener("visibilitychange", this.visibilityHandler);
        this.visibilityHandler = null;
      }
    },
    initializeMonitor() {
      this.setupVisibilityListener();
      this.restartMonitor();
    },
    getServiceCurrentTime() {
      return new Promise(async resolve => {
        try {
          const res = await this.$common.http({
            url: "/api/service/current_time",
            method: "get"
          });
          this.initTime = Number(res.data.data.current_time) + 1;
          resolve();
        } catch (error) {
        }
      });
    },
    onInstruction(row) {
      this.$confirm(`确认推送指令？`, "提示").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/send_c3",
            data: {
              id: row.id
            }
          });
          this.$message.success("推送成功");
          this.refreshData();
        } catch (error) {
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initializeMonitor();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.teardownMonitor();
    next();
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common";
</style>
